import React, { Component } from 'react'; //different
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username: "",
            reviewText: "",
            ratings: {
                speed: 0,  // ความเร็ว ฝาก-ถอน
                service: 0,  // บริการ
                stability: 0,  // ความมั่นคง
            },
            postDisabled: false,  // กำหนดว่าปุ่มโพสต์จะถูกปิดไว้ก่อน
        };
    }

    handleClick = (category, index) => {
        this.setState((prevState) => ({
            ratings: {
                ...prevState.ratings,
                [category]: index,
            },
        }));
    };
    handlePostReview = () => {
        const { username, reviewText, ratings } = this.state;
        const postData = {
            username,
            reviewText,
            ratings,
            date: new Date().toLocaleString(), // เวลาที่โพสต์
        };

        console.log("โพสต์ข้อมูล:", postData);

        // คุณสามารถส่ง postData ไปยัง API หรือทำงานอื่นๆ ที่นี่
        // เช่น this.props.submitReview(postData);

        // รีเซ็ตฟอร์มหลังจากโพสต์
        this.setState({
            username: "",
            reviewText: "",
            ratings: {
                speed: 0,
                service: 0,
                stability: 0,
            },
        });
    };

    checkFormValidity = () => {
        const { username, reviewText, ratings } = this.state;

        // ตรวจสอบจำนวนคำในข้อความรีวิว
        const wordCount = reviewText.trim().split(/\s+/).length;
        const isReviewValid = wordCount >= 10;  // ต้องมีอย่างน้อย 10 คำ

        // ตรวจสอบการเลือกดาวครบทุกอัน
        const isRatingValid = ratings.speed > 0 && ratings.service > 0 && ratings.stability > 0;

        // ตรวจสอบทั้ง 2 ข้อกำหนด
        const isFormValid = username.trim() !== "" && isReviewValid && isRatingValid;

        this.setState({ postDisabled: !isFormValid });
    };

    // ฟังก์ชันจัดการกรอกข้อความรีวิว
    handleReviewChange = (e) => {
        this.setState({ reviewText: e.target.value }, this.checkFormValidity);
    };
    renderStars(category) {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <div
                    key={i}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleClick(category, i)} // เมื่อคลิกที่ดาวจะเปลี่ยน rating ของหมวดหมู่ที่กำหนด
                >
                    <svg
                        width={14}
                        height={13}
                        viewBox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.28671 1.00431C6.51122 0.313323 7.48878 0.313323 7.71329 1.00431L8.55835 3.60512C8.72569 4.12015 9.20564 4.46885 9.74717 4.46885H12.4818C13.2084 4.46885 13.5104 5.39856 12.9227 5.82561L10.7103 7.433C10.2722 7.7513 10.0888 8.31551 10.2562 8.83054L11.1012 11.4314C11.3258 12.1223 10.5349 12.6969 9.94711 12.2699L7.73473 10.6625C7.29662 10.3442 6.70338 10.3442 6.26527 10.6625L4.05289 12.2699C3.4651 12.6969 2.67424 12.1223 2.89875 11.4314L3.74381 8.83054C3.91115 8.31552 3.72783 7.7513 3.28972 7.433L1.07734 5.82561C0.489552 5.39856 0.791634 4.46885 1.51818 4.46885H4.25283C4.79436 4.46885 5.27431 4.12015 5.44165 3.60512L6.28671 1.00431Z"
                            fill={i <= this.state.ratings[category] ? "#FF9D18" : "#4D4D4D"} // เปลี่ยนสีดาวตามการเลือก
                            stroke="#646361"
                            strokeWidth="0.5"
                        />
                    </svg>
                </div>
            );
        }
        return stars;
    }
    render() {
        return (
            <>
                <main className="no-scrollbar z-40 flex flex-1 flex-col justify-start overflow-y-auto">
                    <div
                        className="w-full min-h-full pt-2 flex flex-col justify-start items-center"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <div className="w-full overflow-y-auto no-scrollbar mb-auto pb-14">
                            <div className="relative w-full h-[48px] flex items-center px-2 py-3 md:px-14">
                                <div>
                                    <button className="flex items-center" type="button" onClick={(e) => this.props.onNavigate(
                                        `/review`
                                    )} >
                                        <div className=" relative w-[32px] h-[32px] md:w-[36px] md:h-[36px] ">
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "absolute",
                                                    inset: 0
                                                }}
                                            >
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/back.png"
                                                    decoding="async"
                                                    data-nimg="fill"
                                                    style={{
                                                        filter: "hue-rotate(191deg) brightness(1)",
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    </button>
                                </div>
                                <div className="flex-grow text-center font-[700] leading-[1.3] text-[15px] xs:text-[17px] md:text-[25px] truncate">
                                    ให้คะแนนและเขียนรีวิว
                                </div>
                            </div>
                            <div className="mt-[-10px] p-3 sm:p-4 ">
                                <div className="bg-[#161616] mb-3 p-3 sm:p-4 border border-[#393939] rounded-[9px]">
                                    <div
                                        className="bg-[#0f0f12] border border-[#393939] p-2 rounded-[5px]"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <div className="border-b border-b-[#393939] bg-[#0f0f12] py-2.5 flex items-center justify-between mb-1">
                                            <div className="flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
                                                    <path
                                                        fill="#38C142"
                                                        d="M2.667 5.867a.4.4 0 0 1-.4-.4v-.534a.4.4 0 0 1 .8 0v.534a.4.4 0 0 1-.4.4Z"
                                                    />
                                                    <path
                                                        fill="#38C142"
                                                        d="M2.733 5.333H2a.4.4 0 0 1 0-.8h.733a.2.2 0 0 0 0-.4H2.6a1.001 1.001 0 0 1 0-2h.733a.4.4 0 0 1 0 .8H2.6a.2.2 0 0 0 0 .4h.133a1.001 1.001 0 0 1 0 2Z"
                                                    />
                                                    <path
                                                        fill="#38C142"
                                                        d="M2.667 2.933a.4.4 0 0 1-.4-.4V2a.4.4 0 0 1 .8 0v.533a.4.4 0 0 1-.4.4ZM13.334 14.4a.4.4 0 0 1-.4-.4v-.533a.4.4 0 0 1 .8 0V14a.4.4 0 0 1-.4.4Z"
                                                    />
                                                    <path
                                                        fill="#38C142"
                                                        d="M13.4 13.867h-.733a.4.4 0 0 1 0-.8h.733a.2.2 0 0 0 0-.4h-.133a1.001 1.001 0 0 1 0-2H14a.4.4 0 0 1 0 .8h-.733a.2.2 0 0 0 0 .4h.133a1.001 1.001 0 0 1 0 2Z"
                                                    />
                                                    <path
                                                        fill="#38C142"
                                                        d="M13.334 11.466a.4.4 0 0 1-.4-.4v-.533a.4.4 0 0 1 .8 0v.534a.4.4 0 0 1-.4.4Z"
                                                    />
                                                    <path
                                                        fill="url(#a)"
                                                        d="M14.137 1.602c-2.499-.045-5.348 1.261-7.152 3.287a6.768 6.768 0 0 0-4.638 1.975.267.267 0 0 0 .15.454l2.055.295-.254.284a.266.266 0 0 0 .01.366l3.428 3.428a.266.266 0 0 0 .367.01l.284-.254.294 2.056c.015.1.094.174.19.206.024.008.05.011.075.011a.301.301 0 0 0 .207-.086 6.754 6.754 0 0 0 1.958-4.62c2.028-1.808 3.345-4.656 3.287-7.152a.268.268 0 0 0-.261-.26Zm-2.458 4.604c-.26.26-.6.39-.943.39a1.33 1.33 0 0 1-.943-.39 1.336 1.336 0 0 1 0-1.886c.52-.52 1.366-.52 1.886 0 .52.52.52 1.366 0 1.886Z"
                                                    />
                                                    <path
                                                        fill="#757575"
                                                        d="M3.052 10.616c-.57.57-1.354 3.149-1.441 3.44a.267.267 0 0 0 .332.333c.292-.088 2.87-.871 3.44-1.442a1.65 1.65 0 0 0 0-2.331 1.65 1.65 0 0 0-2.33 0Z"
                                                    />
                                                    <defs>
                                                        <linearGradient
                                                            id="a"
                                                            x1="8.334"
                                                            x2="8.334"
                                                            y1="1.601"
                                                            y2="13.72"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#FDCF2A" />
                                                            <stop offset={1} stopColor="#FF9C1A" />
                                                            <stop offset={1} stopColor="#22538C" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>
                                                </svg>

                                                <p className="text-[11px] xs:text-[12px] sm:text-[14px] md:text-[14px] ml-2 font-weight[700]">
                                                    ความเร็ว ฝาก-ถอน
                                                </p>
                                            </div>
                                            <div>
                                                <div
                                                    className="rating undefined"
                                                    style={{ display: "flex", gap: 4 }}
                                                >
                                                    {/* ใส่ renderStars ที่นี่ */}
                                                    {this.renderStars('speed')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="border-b border-b-[#393939] bg-[#0f0f12] py-2.5 flex items-center justify-between mb-1">
                                            <div className="flex items-center">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={16}
                                                    height={16}
                                                    fill="none"
                                                >
                                                    <path
                                                        fill="url(#a)"
                                                        d="M12.059 7.6a3.83 3.83 0 0 1-.418 1.736 3.959 3.959 0 0 1-1.167 1.379 4.122 4.122 0 0 1-1.676.738c-.61.118-1.239.1-1.84-.055l-1.643.919a.496.496 0 0 1-.536-.034.454.454 0 0 1-.173-.493l.42-1.517A3.878 3.878 0 0 1 3.942 7.6c0-2.168 1.82-3.931 4.058-3.931 2.238 0 4.059 1.763 4.059 3.93Zm-5.187 0a.461.461 0 0 0-.141-.332.495.495 0 0 0-.612-.058.472.472 0 0 0-.178.21.455.455 0 0 0 .106.511.49.49 0 0 0 .527.101.48.48 0 0 0 .217-.172.458.458 0 0 0 .081-.26Zm1.612 0a.43.43 0 0 0-.02-.136.529.529 0 0 0-.061-.124.46.46 0 0 0-.175-.153.527.527 0 0 0-.18-.054.512.512 0 0 0-.316.077.468.468 0 0 0-.194.526.448.448 0 0 0 .088.16.467.467 0 0 0 .234.152.583.583 0 0 0 .14.02.495.495 0 0 0 .427-.248.495.495 0 0 0 .055-.174.436.436 0 0 0 .002-.046Zm1.613 0a.461.461 0 0 0-.141-.332.495.495 0 0 0-.612-.058.472.472 0 0 0-.178.21.455.455 0 0 0 .106.511.489.489 0 0 0 .527.101.481.481 0 0 0 .217-.172.458.458 0 0 0 .081-.26Z"
                                                    />
                                                    <path
                                                        fill="#757575"
                                                        d="M15.992 8.582a2.19 2.19 0 0 1-.604 1.602 2.337 2.337 0 0 1-1.703.724c-.162 0-.324-.018-.482-.051a6.109 6.109 0 0 1-1.808 1.76 6.328 6.328 0 0 1-2.388.902c-.1.287-.302.53-.568.69a1.378 1.378 0 0 1-1.696-.236 1.271 1.271 0 0 1-.075-1.657c.189-.241.459-.411.763-.48.305-.07.625-.033.905.102s.502.36.628.638a5.248 5.248 0 0 0 3.063-1.74 4.95 4.95 0 0 0 1.2-3.236c0-2.792-2.345-5.063-5.227-5.063S2.773 4.808 2.773 7.6c0 .863.227 1.712.661 2.465a.301.301 0 0 1 .033.08.454.454 0 0 1-.012.347.476.476 0 0 1-.256.242 2.344 2.344 0 0 1-.992.17 2.336 2.336 0 0 1-1.596-.72 2.19 2.19 0 0 1-.603-1.602c.01-.236.004-.446-.002-.649-.005-.19-.01-.389-.001-.595.027-.576.283-1.12.714-1.518a2.348 2.348 0 0 1 1.601-.615C3.277 3.085 5.463 1.6 8 1.6s4.723 1.485 5.68 3.605a2.346 2.346 0 0 1 1.601.615c.432.397.688.941.714 1.518.01.206.004.404-.002.595a8.84 8.84 0 0 0 0 .65Z"
                                                    />
                                                    <defs>
                                                        <linearGradient
                                                            id="a"
                                                            x1="8.001"
                                                            x2="8.001"
                                                            y1="3.669"
                                                            y2="12.38"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#FDCF2A" />
                                                            <stop offset={1} stopColor="#FF9C1A" />
                                                            <stop offset={1} stopColor="#22538C" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>
                                                </svg>
                                                <p className="text-[11px] xs:text-[12px] sm:text-[14px] md:text-[14px] ml-2 font-weight[700]">
                                                    บริการ
                                                </p>
                                            </div>
                                            <div>
                                                <div
                                                    className="rating undefined"
                                                    style={{ display: "flex", gap: 4 }}
                                                >
                                                    {/* ใส่ renderStars ที่นี่ */}
                                                    {this.renderStars('service')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-[#0f0f12] py-2.5 flex items-center justify-between">
                                            <div className="flex items-center">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={16}
                                                    height={16}
                                                    fill="none"
                                                >
                                                    <path
                                                        fill="#757575"
                                                        d="M12.247 10.84a1.619 1.619 0 0 1-1.617-1.616 1.62 1.62 0 0 1 1.617-1.618c.892 0 1.617.726 1.617 1.618 0 .891-.725 1.617-1.617 1.617ZM3.753 10.84a1.619 1.619 0 0 1-1.617-1.616 1.62 1.62 0 0 1 1.617-1.618c.892 0 1.617.726 1.617 1.618 0 .891-.725 1.617-1.617 1.617Z"
                                                    />
                                                    <path
                                                        fill="url(#a)"
                                                        d="M10.813 1.925a1.39 1.39 0 0 1-1.251-.773l-.06-.119A.422.422 0 0 0 9.125.8h-2.25c-.16 0-.306.09-.377.233l-.06.119a1.39 1.39 0 0 1-1.25.773.422.422 0 0 0-.422.422v2.407c0 .947.298 1.849.863 2.608A4.337 4.337 0 0 0 7.88 8.94a.422.422 0 0 0 .242 0 4.337 4.337 0 0 0 2.25-1.577c.565-.76.864-1.661.864-2.608V2.347a.422.422 0 0 0-.422-.422ZM9.492 4.381 7.9 5.972a.42.42 0 0 1-.597 0l-.795-.795a.422.422 0 1 1 .596-.597l.497.497 1.293-1.293a.422.422 0 1 1 .597.597Z"
                                                    />
                                                    <path
                                                        fill="#757575"
                                                        d="M13.973 10.977a2.453 2.453 0 0 1-3.453-.002c-.236.17-.446.374-.623.605l.232.203a3.235 3.235 0 0 1 1.106 2.433v.984h3.544a.422.422 0 0 0 .422-.422v-1.406c0-.985-.485-1.858-1.228-2.395ZM2.028 10.977A2.951 2.951 0 0 0 .8 13.372v1.406c0 .233.189.422.422.422h3.544v-.984c0-.93.403-1.817 1.105-2.433l.232-.203a2.955 2.955 0 0 0-.623-.605 2.453 2.453 0 0 1-3.452.002Z"
                                                    />
                                                    <path
                                                        fill="url(#b)"
                                                        d="M9.573 12.418a2.173 2.173 0 0 1-3.146 0 2.385 2.385 0 0 0-.818 1.798v.984h4.782v-.984c0-.716-.317-1.36-.818-1.798Z"
                                                    />
                                                    <path
                                                        fill="url(#c)"
                                                        d="M8 12.247c-.737 0-1.336-.6-1.336-1.336 0-.736.6-1.336 1.336-1.336.737 0 1.336.6 1.336 1.336 0 .737-.6 1.336-1.336 1.336Z"
                                                    />
                                                    <defs>
                                                        <linearGradient
                                                            id="a"
                                                            x1={8}
                                                            x2={8}
                                                            y1="0.8"
                                                            y2="8.956"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#FDCF2A" />
                                                            <stop offset={1} stopColor="#FF9C1A" />
                                                            <stop offset={1} stopColor="#22538C" stopOpacity={0} />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="b"
                                                            x1={8}
                                                            x2={8}
                                                            y1="12.418"
                                                            y2="15.2"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#FDCF2A" />
                                                            <stop offset={1} stopColor="#FF9C1A" />
                                                            <stop offset={1} stopColor="#22538C" stopOpacity={0} />
                                                        </linearGradient>
                                                        <linearGradient
                                                            id="c"
                                                            x1={8}
                                                            x2={8}
                                                            y1="9.575"
                                                            y2="12.247"
                                                            gradientUnits="userSpaceOnUse"
                                                        >
                                                            <stop stopColor="#FDCF2A" />
                                                            <stop offset={1} stopColor="#FF9C1A" />
                                                            <stop offset={1} stopColor="#22538C" stopOpacity={0} />
                                                        </linearGradient>
                                                    </defs>
                                                </svg>
                                                <p className="text-[11px] xs:text-[12px] sm:text-[14px] md:text-[14px] ml-2 font-weight[700]">
                                                    ความมั่นคง
                                                </p>
                                            </div>
                                            <div>
                                                <div
                                                    className="rating undefined"
                                                    style={{ display: "flex", gap: 4 }}
                                                >
                                                    {/* ใส่ renderStars ที่นี่ */}
                                                    {this.renderStars('stability')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="mt-2 mb-2"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <p className="text-[#A39B72] text-[11px] xs:text-[12px] sm:text-[14px] md:text-[14px] ml-2 font-bold">
                                            เกณณ์การให้ดาว
                                        </p>
                                        <p className="text-[#A39B72] text-[11px] xs:text-[12px] sm:text-[14px] md:text-[14px] ml-2 ">
                                            5 = ดีมาก , 4 = ดี, 3 = ปานกลาง , 2 = พอใช้, 1 = ควรปรับปรุง
                                        </p>
                                    </div>
                                </div>
                                <div className="bg-[#161616] mb-3 p-3 sm:p-4 border border-[#393939] rounded-[9px]">
                                    <p
                                        className="text-[#FFFFFF] text-[12px] xs:text-[13px] sm:text-[15px] md:text-[15px] ml-2 font-bold"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        ข้อความรีวิว
                                    </p>
                                    <div
                                        className="mb-3.5"
                                        style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                                    >
                                        <textarea
                                            className="border border-[#393939] bg-[#0f0f12] py-2.5 flex items-center justify-between mb-1 text-[12px] xs:text-[12px] sm:text-[12px] md:text-[12px] w-full h-[120px] rounded-md p-3 mt-1.5"
                                            placeholder="(แสดงความคิดเห็น)
ขอความกรุณาลูกค้าแสดงความคิดเห็นด้วยความสุภาพ ไม่ใช้ถ้อยคำหยาบคาย หรือ เผยแพร่ภาพที่ไม่เหมาะสมด้วยครับ"
                                            maxLength={600}
                                            style={{ height: 100 }}
                                            value={this.state.reviewText}
                                            onChange={this.handleReviewChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full sticky bottom-0 bg-[#0C0B0D] pt-5 pb-11">
                            <div
                                className="px-3 cursor-pointer w-full"
                                style={{ filter: "hue-rotate(191deg) brightness(1)" }}
                            >
                                <div className={`${this.state.postDisabled ? 'primary-button w-full h-[48px] rounded-[8px] flex justify-center items-center' : 'bg-[#24221E] border-[2px] border-[#4D4D4D] cursor-not-allowed w-full h-[48px] rounded-[8px] flex justify-center items-center'}`}>
                                    <button
                                        className="flex items-center justify-center"
                                        disabled={this.state.postDisabled}
                                        onClick={this.handlePostReview}
                                    >
                                        <div className="mr-2" />
                                        <div className={` ${this.state.postDisabled ? 'text-white mr-2 text-[14px] xs:text-[14px] sm:text-[15px] md:text-[15px] font-bold' : 'text-[#878787] mr-2 text-[14px] xs:text-[14px] sm:text-[15px] md:text-[15px] font-bold'}`}>
                                            โพสต์รีวิว
                                        </div>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </main>



            </>
        );
    }
}
export default App;
